import { render } from "./FormGroupWrapper.vue?vue&type=template&id=f1f40eba&lang=pug"
import script from "./FormGroupWrapper.vue?vue&type=script&lang=js"
export * from "./FormGroupWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/gitlab-runner/builds/Ysdfp3TDT/0/z2a/z-tracker-partners/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__